import format from 'date-fns/format'
import isFuture from 'date-fns/is_future'
import isPast from 'date-fns/is_past'
import dateFnsSubYears from 'date-fns/sub_years'
import isAfter from 'date-fns/is_after'
import addYears from 'date-fns/add_years'
import subDays from 'date-fns/sub_days'

function fixDateForValidation(date, raw) {
  let fixedDate = date
  let fullDate = ''
  if (date.includes('.')) {
    const dateParts = date.split('.')
    const year = dateParts[2]
    const month = dateParts[1] - 1 // -1 because new Date() uses  the month-Index [0(JAN)-11(DEZ)]
    const day = dateParts[0]

    fullDate = new Date(year, month, day)
    fixedDate = format(fullDate, 'YYYY-MM-DD')
  }
  return raw ? fullDate : fixedDate
}

export function inTheFuture(date) {
  return isFuture(fixDateForValidation(date))
}

export function inThePast(date) {
  return isPast(fixDateForValidation(date))
}

export function isAdult(date) {
  const eighteenYearAgo = dateFnsSubYears(new Date(), 18)
  return fixDateForValidation(date, true) <= eighteenYearAgo
}

export function atMostOneYearInFuture(date) {
  return !isAfter(fixDateForValidation(date), addYears(new Date(), 1))
}

export function atMostOneWeekInPast(date) {
  return isAfter(fixDateForValidation(date), subDays(new Date(), 8))
}

export default {
  inTheFuture,
  inThePast,
  isAdult,
  atMostOneYearInFuture,
  atMostOneWeekInPast,
}
